module.exports = __webpack_public_path__ + "img/login-v2.1ee0c19c.svg";